export const StorageKeys = {
  userId: 'app-login-userId',
  token: 'app-login-token',
  invoiceFilterCategory: 'payme-invoiceFilterCategory',
  invoiceSearchString: 'payme-invoiceSearchString',
  invoiceSortObject: 'payme-invoiceSortObject',
  invoiceFilterObject: 'payme-invoiceFilterObject',
  customerInvoiceSearchString: 'payme-customerInvoiceSearchString',
  customerInvoiceSortObject: 'payme-customerInvoiceSortObject',
  customerInvoiceFilterObject: 'payme-customerInvoiceFilterObject',
  customerSearchString: 'payme-customerSearchString',
  customerSortObject: 'payme-customerSortObject',
  customerFilterObject: 'payme-customerFilterObject',
  projectSearchString: 'payme-projectSearchString',
  projectSortObject: 'payme-projectSortObject',
  projectFilterObject: 'payme-projectFilterObject',
  filter_invoice_pdf: 'filter_invoice_pdf',

  invoiceIssuePeriodFilter: 'payme-invoiceIssuePeriodFilter',
  invoiceStatusFilter: 'payme-invoiceStatusFilter',
}
